// extracted by mini-css-extract-plugin
module.exports = {"videoPlayerButton":"herovideo_videoPlayerButton__U8M4Y","playButton":"herovideo_playButton__Fr2_T","playButtonText":"herovideo_playButtonText__Zrsf2"};